.card {
    display: flex;
    margin-bottom: var(--spacer-64);

    @media print {
        break-inside: avoid;
    }
}

.landing,
.miniCart,
.confirmation {
    composes: card;
}

.miniCart {
    margin-bottom: var(--spacer-24);

    + .card {
        padding-top: var(--spacer-24);
    }
}

.picture {
    display: block;
    width: 33%;
    flex-shrink: 0;
    background-color: var(--off-white);

    .landing &,
    .miniCart & {
        height: fit-content;
    }

    .confirmation & {
        display: flex;
    }

    @media print {
        width: 25%;
    }
}

.image {
    display: block;
    width: 100%;
    aspect-ratio: 1;
    object-fit: contain;

    .confirmation & {
        object-fit: contain;
    }
}

.cardContent {
    padding-inline: var(--spacer-40);

    .confirmation & {
        padding-block: var(--spacer-40);
    }

    .miniCart & {
        padding: 0 var(--spacer-24);
    }

    > *:not(:first-child, .removeButton) {
        margin-top: var(--spacer-24);
        padding-top: var(--spacer-24);
        border-top: 1px solid var(--gray-300);
    }
}

.removeButton {
    margin-top: var(--spacer-24);
    font: var(--font-text-link-14);
    text-decoration: underline;
}
